export default {
  "root": "_root_1s92x_1"
};import "ni:sha-256;2G4S39Dn4CqyVMSo7IcjhbRx3mRBtzmgSX6hPk0eV2w";